import { LevelTemplate as BackendLevelTemplate } from "@longtail-education/superprep-data-model-frontend"

/**
 * Represents a level template with extended functionality for the frontend.
 */
export class LevelTemplate extends BackendLevelTemplate {
  /** The unique identifier of the level template. */
  declare id: string
}
